import { PrivacyPolicy } from "@/components";
import useBackward from "@/hooks/useBackward";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/privacy-policy")({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation("nav");
	const handleOnBack = useBackward();
	return (
		<div className="h-full container relative flex flex-col">
			<AppBar position="fixed" className="!bg-white !shadow-none">
				<Toolbar variant="dense" className="wrapper w-full h-14">
					<IconButton
						edge="start"
						color="inherit"
						aria-label="backspace"
						className="mr-2"
						onClick={() => handleOnBack()}
					>
						<KeyboardBackspaceIcon className="text-dark text-2xl" />
					</IconButton>
					<p className="text-sm text-dark font-semibold">
						{t("nav:privacyPolicy")}
					</p>
				</Toolbar>
			</AppBar>
			<div className="flex-1 mt-12 py-4">
				<PrivacyPolicy />
			</div>
		</div>
	);
}
